module.exports = __webpack_public_path__ + "media/images/pc/static/about-0d2f25250c5c3f49a372b3c10824dd53.png";